export const SEG_STYLE_MODE = {
    SIMPLE: 'simple',
    ADVANCED: 'advanced',
};

export const DEFAULT_SEGMENTATION_CATEGORIES = [
    { id: 'class-1', label: 'Class 1', color: '#1f77b4' },
    { id: 'class-2', label: 'Class 2', color: '#ff7f0e' },
];

const DEFAULT_VIEW_OPACITY = {
    fill: 0.35,
    stroke: 1,
};

function clamp01(value, fallback) {
    const n = Number(value);
    if (!Number.isFinite(n)) return fallback;
    if (n < 0) return 0;
    if (n > 1) return 1;
    return n;
}

function normalizeCategory(raw, index) {
    const id = String(raw?.id ?? '').trim() || `class-${index + 1}`;
    const label = String(raw?.label ?? '').trim() || id;
    const color = String(raw?.color ?? '').trim() || '#1f77b4';
    const style = raw?.style && typeof raw.style === 'object' ? raw.style : {};
    return {
        id,
        label,
        color,
        style: {
            strokeColor: typeof style.strokeColor === 'string' ? style.strokeColor : undefined,
            fillColor: typeof style.fillColor === 'string' ? style.fillColor : undefined,
            strokeWidth: Number.isFinite(Number(style.strokeWidth)) ? Number(style.strokeWidth) : 2,
        },
    };
}

export function normalizeSegmentationConfig(config) {
    const next = config && typeof config === 'object' ? config : {};
    const styleMode = next.styleMode === SEG_STYLE_MODE.ADVANCED
        ? SEG_STYLE_MODE.ADVANCED
        : SEG_STYLE_MODE.SIMPLE;
    const rawCats = Array.isArray(next.categories) ? next.categories : [];
    const categories = (rawCats.length > 0 ? rawCats : DEFAULT_SEGMENTATION_CATEGORIES)
        .map(normalizeCategory);
    const tools = Array.isArray(next.tools) && next.tools.length > 0
        ? next.tools.filter((t) => ['polygon', 'brush', 'wand'].includes(t))
        : ['polygon', 'brush', 'wand'];
    const booleanOps = next.booleanOps && typeof next.booleanOps === 'object' ? next.booleanOps : {};
    const view = next.view && typeof next.view === 'object' ? next.view : {};

    return {
        ...next,
        styleMode,
        categories,
        tools,
        booleanOps: {
            trimSelectedEnabled: booleanOps.trimSelectedEnabled !== false,
            trimOthersEnabled: booleanOps.trimOthersEnabled !== false,
        },
        view: {
            fillOpacity: clamp01(view.fillOpacity, DEFAULT_VIEW_OPACITY.fill),
            strokeOpacity: clamp01(view.strokeOpacity, DEFAULT_VIEW_OPACITY.stroke),
        },
    };
}

export function getCategoryEffectiveStyle(category, styleMode) {
    const strokeWidth = Number.isFinite(Number(category?.style?.strokeWidth))
        ? Number(category.style.strokeWidth)
        : 2;
    const baseColor = category?.color || '#1f77b4';
    if (styleMode === SEG_STYLE_MODE.ADVANCED) {
        return {
            strokeColor: category?.style?.strokeColor || baseColor,
            fillColor: category?.style?.fillColor || baseColor,
            strokeWidth,
        };
    }
    return {
        strokeColor: baseColor,
        fillColor: baseColor,
        strokeWidth,
    };
}

export function findCategoryById(categories, categoryId) {
    return (categories || []).find((c) => String(c.id) === String(categoryId)) || null;
}

export function buildCategoryStyleForTool(category, styleMode, fillOpacity, strokeOpacity) {
    const style = getCategoryEffectiveStyle(category, styleMode);
    return {
        strokeColor: style.strokeColor,
        fillColor: style.fillColor,
        strokeWidth: style.strokeWidth,
        fillOpacity: clamp01(fillOpacity, DEFAULT_VIEW_OPACITY.fill),
        strokeOpacity: clamp01(strokeOpacity, DEFAULT_VIEW_OPACITY.stroke),
        rescale: { strokeWidth: style.strokeWidth },
    };
}

